/**
 * Google Calendar Query Key Factory
 *
 * Centralized query key management for React Query operations
 * following NotePlan Web caching patterns.
 */

import { QueryKeyFactory } from './types'

// ============================================================================
// Query Key Factory Implementation
// ============================================================================

export const googleQueryKeys: QueryKeyFactory = {
  /**
   * Query key for user's Google accounts
   * @param userId NotePlan user ID
   * @returns Query key array
   */
  accounts: (userId: string) => ['accounts', userId],

  /**
   * Query key for access token for a specific account
   * @param userId NotePlan user ID
   * @param accountId Google account ID
   * @returns Query key array
   */
  accessToken: (userId: string, accountId: string) => [
    'accessToken',
    userId,
    accountId,
  ],

  /**
   * Query key for calendars for a specific account
   * @param userId NotePlan user ID for user-specific caching
   * @param accountId Google account ID
   * @returns Query key array
   */
  calendars: (userId: string, accountId: string) => [
    'calendars',
    userId,
    accountId,
  ],

  /**
   * Query key for events for a specific calendar and date
   * @param userId NotePlan user ID for user-specific caching
   * @param accountId Google account ID
   * @param calendarId Google calendar ID
   * @param date Date string (YYYYMMDD format)
   * @returns Query key array
   */
  events: (
    userId: string,
    accountId: string,
    calendarId: string,
    date: string
  ) => ['events', userId, accountId, calendarId, date],
}
